import HTTP from "../../http";
import { generateQueryString } from "../../../utils";

const PRODUCTS_ENDPOINT = "/products";
const RECOMMENDATIONS_ENDPOINT = "/recommendations";

export async function getRecommendations(query) {
  return await HTTP.get(
    PRODUCTS_ENDPOINT + RECOMMENDATIONS_ENDPOINT + generateQueryString(query)
  );
}
